import React, { useState, useEffect } from "react";
import loadable from "@loadable/component";
import PropTypes from "prop-types";
const Lottie = loadable(() => import("react-lottie"), {ssr: false});
import styles from "./styles.css";
import CheckAnimation from "./lottie-files/check-animation.json";
import CarAnimation from "./lottie-files/car-animation.json";
import CarAnimationV2 from "./lottie-files/car-animation-v2.json";
import Modal from "../modal";
import { yieldToMain } from "../../../utils/helpers/yield-to-main";
import { Text } from "@cars24/turbo-web/lib/text";
import { useTokens } from "@cars24/turbo-web/lib/theme-provider";

const DEFAULT_LOTTIE_OPTIONS = {
    loop: false,
    autoplay: true,
    animationData: CheckAnimation,
    rendererSettings: { preserveAspectRatio: "xMidYMid slice" }
};

const CAR_LOTTIE_OPTIONS = {
    ...DEFAULT_LOTTIE_OPTIONS,
    animationData: CarAnimation
};

const CAR_LOTTIE_OPTIONS_V2 = {
    ...DEFAULT_LOTTIE_OPTIONS,
    animationData: CarAnimationV2
};

const CarAnimationLoader = ({
    title = "Whoo-hoo! It seems we have already inspected your car",
    showCheckMark = true,
    isFullScreen = false,
    heading = "",
    description = "",
    isVariant = false
}) => {

    const [isLoading, setIsLoading] = useState(true);
    const lazyRenderLottie = async () => {
        await yieldToMain();
        setIsLoading(false);
    };

    useEffect(() => {
        lazyRenderLottie();
    }, []);

    const { tokens } = useTokens();

    if (isVariant) {
        return (
            <div styleName={"styles.fetchingDetailsPopup"}>
                <div styleName={"styles.lottieWrapperVariant styles.lottieWrapper"}>
                    <div styleName={"styles.carAnimationVariant styles.carAnimation"}>
                        <Lottie options={{...CAR_LOTTIE_OPTIONS_V2, loop: true}} width="80%" height="40%" />
                    </div>
                    <h3>{title}</h3>
                    <Text fontWeight="regular" size="200" color={tokens.text_default_text_secondary}>{description}</Text>
                </div>
            </div>
        );
    }

    return (
        isFullScreen ? <div styleName={"styles.fetchingDetailsPopup"}>
            <div styleName={"styles.wrapper"}>
                {!isLoading &&
                    <div styleName={"styles.carAnimationLoader"}>
                        <Lottie options={{...CAR_LOTTIE_OPTIONS, loop: true}} width="100%" height="40%" />
                    </div>
                }
                <Text
                    align="center"
                    as="h4"
                    color="#0F0F10"
                    fontWeight="bold"
                    size="350"
                    transform="none"
                >
                    {heading}
                </Text>
            </div>

        </div> :
            <Modal isOpen={true}>
                <div styleName={"styles.fetchingDetailsPopup"}>
                    <div styleName={"styles.lottieWrapper"}>
                        {
                            showCheckMark &&
                        <Lottie options={{...DEFAULT_LOTTIE_OPTIONS}} width="36px" height="36px" />
                        }
                        <h3 style={{ width: "230px" }}>{title}</h3>
                        {!isLoading &&
                        <div styleName={"styles.carAnimation"}>
                            <Lottie options={{...CAR_LOTTIE_OPTIONS, loop: true}} width="100%" height="40%" />
                        </div>
                        }
                    </div>

                </div>
            </Modal>

    );
};

CarAnimationLoader.propTypes = {
    title: PropTypes.object,
    showCheckMark: PropTypes.bool,
    isFullScreen: PropTypes.bool,
    heading: PropTypes.string,
    isVariant: PropTypes.bool,
    description: PropTypes.string
};

export default CarAnimationLoader;
